import * as React from "react";
import { User, Category } from "../api/classes";
import { Avatar, Typography, Select, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import { RouteComponentProps } from "react-router-dom";
import * as actions from "../store/cases/actions";
import FolderIcon from "@material-ui/icons/Folder";
import * as constants from "../api/constants";
interface Props {
  value: string;
  onChange?: () => void;
  onSelect: (id: string) => void;
  readOnly?: boolean;
  style?: React.CSSProperties;
}
const items = [
  {
    id: constants.FOLDER_NEWS_FEED,
    label: "News Feed"
  },
  {
    id: constants.FOLDER_COLD_CASES,
    label: "Cold Cases"
  },
  {
    id: constants.FOLDER_ARCHIVE,
    label: "Archive"
  }
];
export default class FolderSelect extends React.Component<Props> {
  handleChange = e => {
    this.props.onSelect(e.target.value);
  };
  render() {
    const { value } = this.props;
    if (this.props.readOnly) {
      return this.renderReadonly();
    }
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative"
        }}
      >
        <FolderIcon
          style={{
            position: "absolute",
            left: 0,
            top: 5,
            width: 20,
            height: 20
          }}
        />
        <Select
          disableUnderline
          style={{
            alignSelf: "flex-start",
            paddingLeft: 32
          }}
          value={value}
          onChange={this.handleChange}
          inputProps={{
            name: "age",
            id: "age-simple"
          }}
        >
          {items.map(u => {
            return (
              <MenuItem key={u.id} value={u.id}>
                {u.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
  renderReadonly() {
    const folder = items.find(i => i.id === this.props.value);
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 28
        }}
      >
        <FolderIcon
          style={{
            width: 20,
            height: 20,
            marginRight: 12
          }}
        />
        <Typography variant="body2">{folder && folder.label}</Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/folderSelect.tsx